module.exports = __webpack_public_path__ + "img/17.1e98f113.png";